import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons';

export const renderDateControls  = ( moveDate, label, period ) => {
  return (
      <div className="button-container">
      <span className="time-period-label">{label}</span>
      <div className="button-container-row">
        <button type="button" className="control-button arrow" onClick={() => moveDate("previous", period)}>
          <FontAwesomeIcon
            icon={faCaretLeft}
          />
        </button>
        <button type="button" className="control-button arrow" onClick={() => moveDate("next", period)}>
        <FontAwesomeIcon
            icon={faCaretRight}
        />
        </button>

      </div>
    </div>
  )
};
  
export const renderSpecialControls = ( moveDateSpecial, selectedDate, isMobileView, handleAbout, handleFeedback, handleGenome, handleDates ) => {
  return (
  <>
      {isMobileView ? (
          <>
              <button type="button" className="control-button" onClick={handleAbout}>About</button>
              <button type="button" className="control-button" onClick={handleFeedback}>Feedback</button>
              <button type="button" className="control-button" onClick={handleDates}>TV History</button>
              <button type="button" className="control-button" onClick={handleGenome}>Genome</button>
          </>
      ) : null}
        <button type="button" title="Xmas Day" className="control-button" onClick={() => moveDateSpecial("xmas")}>Xmas</button>
        <button type="button" title="Gauss's Easter Algorithm" className="control-button" onClick={() => moveDateSpecial("easter")}>Easter</button>
        <button type="button" title="First Monday in May" className="control-button" onClick={() => moveDateSpecial("mayDay")}>May Day</button>
        <button type="button" title="First Monday in September" className="control-button" onClick={() => moveDateSpecial("autumn")}>Autumn</button>
        <button type="button" title="Six weeks from First Monday in September" className="control-button" onClick={() => moveDateSpecial("autumn6")}>Autumn+6</button>
        <button type="button" title="Wooo" className="control-button" onClick={() => moveDateSpecial("halloween")}>Halloween</button>
        <button type="button" title="New Year's Day" className="control-button" onClick={() => moveDateSpecial("newYear")}>New Year</button>
        <button type="button" title="New Year's Eve" className="control-button" onClick={() => moveDateSpecial("newYearsEve")}>NYE</button>
        <button type="button" title="Today in the selected year" className="control-button" onClick={() => moveDateSpecial("today")}>Today</button>
        <button type="button" title="Add six weeks (length of a series)" className="control-button" onClick={() => moveDateSpecial("add6wks")}>+6w</button>
        <button type="button" title="Add six months" className="control-button" onClick={() => moveDateSpecial("add6mns")}>+6m</button>
        <button type="button" title="Pick a random day" className="control-button" onClick={() => moveDateSpecial("random")}>Random</button>
      </>
  )
};


